<!--模板界面-->
<template>
	<div class="bg" style="position: relative;">
		<p class="titleText">事件统计</p>
		<img src="../../../../public/static/杭州东杰定制/看板/站点概况/titleBottom.png" style="margin: 10px 0;width: 100%;">
		<vchart style="height: calc(100% - 88px);margin-top: 19px;" themes="dongjieEchart" ref='vchart'></vchart>
		<p class="eventCount flexCenter">总事件数 : <span>{{alarm+earlyWarning+msg}}</span> </p>
		<div class="eventBox flexCenterColumn" style="top: 100px;left: 20px;">
			<div class="flexStart">
				<div class="pointBox" style="background: #5195f2;"></div>
				<p>消 息</p>
			</div>
			<p>{{msg}}</p>
		</div>
		<div class="eventBox flexCenterColumn" style="top: 100px;right: 20px;">
			<div class="flexStart">
				<div class="pointBox" style="background: #14f1f4;"></div>
				<p>预 警</p>
			</div>
			<p>{{earlyWarning}}</p>
		</div>
		<div class="eventBox flexCenterColumn" style="top: 250px;left: 20px;">
			<div class="flexStart">
				<div class="pointBox" style="background: #f4a214;"></div>
				<p>告 警</p>
			</div>
			<p>{{alarm}}</p>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				options: {
					tooltip: {
						trigger: 'item',
						formatter: "{a}</br>{b} : {c} ({d}%)"
					},
					legend: {
						show: false,
					},
					series: [{
						name: '占比',
						type: 'pie',
						radius: ['0%', '45%'],
						data: [],
						label: {
							show: false
						},
					}]
				},
				earlyWarning: 0,
				alarm: 0,
				msg: 0,
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.options.series[0].itemStyle = {
				normal: {
					opacity: 0.7,
				}
			}
			this.$refs.vchart.setData(this.options)
			this.getData()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			dataList() {
				var list = []
				list.push({
					name: "告警",
					value: this.alarm
				})
				list.push({
					name: "预警",
					value: this.earlyWarning
				})
				list.push({
					name: "消息",
					value: this.msg
				})
				return list
			}
		},
		watch: {
			nowUnit(nv, ov) {
				this.getData()
			},
			dataList(nv, ov) {
				this.options.series[0].data = nv
				this.$refs.vchart.setData(this.options, true)
			}
		},
		methods: {
			getData() {
				var today = new Date()
				var year = today.getFullYear()
				var month = today.getMonth()
				var day = today.getDate()
				var todayTime = today.getTime()
				//预警
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', '-1', '1', '', 0, todayTime, '', respon => {
					this.earlyWarning = 0
					if (!isempty(respon)) {
						Object.keys(respon).forEach(key => {
							this.earlyWarning += respon[key]
						});
					}
				})
				//告警
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, '2', '', 0, todayTime, '', respon => {
					this.alarm = 0
					if (!isempty(respon)) {
						Object.keys(respon).forEach(key => {
							this.alarm += respon[key]
						});
					}
				})
				//消息
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, '0', '', 0, todayTime, '', respon => {
					this.msg = 0
					if (!isempty(respon)) {
						Object.keys(respon).forEach(key => {
							this.msg += respon[key]
						});
					}
				})
			}
		}
	}
</script>

<style scoped>
	.bottomImg {
		width: 80%;
		margin: 5% 10% 0 10%;
	}

	.eventBox {
		position: absolute;
		width: 90px;
		height: 40px;
		background-image: url(/static/杭州东杰定制/看板/运维分析/boxBg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	.eventCount {
		top: 49px;
		width: 200px;
		padding: 10px;
		left: calc(50% - 105px);
		text-align: center;
		position: absolute;
		background-image: url(/static/杭州东杰定制/看板/运维分析/cycleBg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	.eventCount>span{
		color: #ed7310;
		font-size: 16px;
		font-weight: bold;
		padding: 0 10px;
	}

	.pointBox {
		height: 10px;
		width: 10px;
		border-radius: 50%;
		margin-right: 10px;
	}
</style>
